export default __webpack_public_path__ + "static/media/G0200-Bradycardia-Algorithm.1712155560000.fe8e8bc2.jpg";